var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("bs-callout bs-callout-" + _vm.category),attrs:{"role":"alert","aria-live":"assertive"}},[_vm._v("\n  "+_vm._s(_vm.message)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }